module.exports = __webpack_public_path__ + "img/share_theme.e429ad4d.jpg";